<template>
  <div class="container" style="overflow: hidden">
    <mapTop
      ref="mapAddress"
      :mylat="mylat"
      :mylng="mylng"
      :isBuy="isBuy"
      :addressInfo="audioInfo"
      :changeOpenAudio="changeOpenAudio"
      @changeLoading="changeLoading"
      @showPrizeDialog="showPrizeDialog"
      :lat="spointx"
      :lon="spointy"
      @audioOpen="audioOpen"
      
    />
   
    <!-- <div class="outOrin" @click="outOrin">

    <img alt="" style="width:44px;height:auto" src="@/static/imgs/BlueMenu.png" />        

        
    </div> -->
    <div class="miniShop" v-if="isShowMiniShop">
             <wx-open-launch-weapp
            id="launch-btn"
            :username="audioInfo.settings?audioInfo.settings.miniAppId:''"
            path="pages/index"
            >
            <script type="text/wxtag-template">
                <style>.btn { padding: 20px;border:none;margin-left:5px;background:none }</style>
                <button class="btn"></button>
            </script>
            </wx-open-launch-weapp>
        </div>
   
    <div class="right-fun">
      <ul >
        <li @click="openRight">
            <img src="@/static/imgs/xuanxiang.png" alt="">
            <span> {{isEnglish ? 'option':'选项'}}  </span>
        </li>
        <li v-show="audioInfo.settings?audioInfo.settings.h5Link || audioInfo.settings.miniAppId:false" @click="gotoShop()">
            <img src="@/static/imgs/shop.png" alt="">
          
            <span>{{isEnglish ? 'Shop':'商城'}}</span>
        </li>
        <li v-show="audioInfo.settings?audioInfo.settings.vrLink:false" @click="gotoVr()">
            <img src="@/static/imgs/vr.png" alt="">
            <span>VR</span>
        </li>
      </ul>
    </div>
<!-- v-show="rightCheck" -->
    <div class="right-mark" v-show="rightCheck" >
        <div class="right-mark-atr" @click="closeRightCheck">

        </div>
        <div class="right-mark-main">
          <div class="Tab"  >
   
            <div >
              
               <!--  -->
                <div
                
                @click="feedBack"
                v-show='true'
                
              >
                <div>
                  <iconx type="fankui" color="rgb(141,141,146)" />
                  <span style="color: rgb(141, 141, 146)">
                    {{ isEnglish ? sliderMap[4].english : sliderMap[4].chinese }}
                  </span>
                </div>
              </div>
               
              <div
             
              @click="changeOpenAudio"
             
             v-if="audioInfo.autoPlay !== 2"
            >
              
              <span>
                {{ isEnglish ? sliderMap[3].english : sliderMap[3].chinese }}
              </span>
              <iconx type="kaiguan_" color="rgb(189,189,189)" v-if="!isOpenAudio" />
              <iconx type="kaiqi3" color="rgb(10,195,128)" v-if="isOpenAudio" />
            </div>
            <div
              
              v-if="audioInfo.showBackImg === 1"
              @click="changeDrawImg"
              
            >
             
              <span>
                {{ isEnglish ? sliderMap[2].english : sliderMap[2].chinese }}
              </span>
               <iconx type="kaiguan_" color="rgb(189,189,189)" v-if="!isDrawImg" />
              <iconx type="kaiqi3" color="rgb(10,195,128)" v-if="isDrawImg" />
            </div>
             
            <div
             
              @click="changeEnglish"
              v-if="audioInfo.supportEng === 1"
            
            >
              
              <span>
                {{ isEnglish ? sliderMap[5].english : sliderMap[5].chinese }}
              </span>
              <iconx type="kaiguan_" color="rgb(189,189,189)" v-if="!isEnglish" />
              <iconx type="kaiqi3" color="rgb(10,195,128)" v-if="isEnglish" />
            
            </div>
           
            <div  @click="complete"  v-if="audioInfo.complete_link">
              <div>
                <iconx  type="tubiaozhizuomoban_canbaorenshenfenleibie_ditu" color="rgb(18,150,219)" />
                <span>全域</span>
              </div>
            </div>
            </div>

          
            
            
        </div>
        </div>
    </div>

    
        
    

    

    <bottomTab
      :info="audioInfo"
      :list="audioList"
      :spointx="spointx"
      :spointy="spointy"
      ref="tabs"
      :isEnglish="isEnglish"
      @choseTour="showTourDialog"
      v-show="!searchDialog && rightCheck!=true"
      @lineUpdate="lineUpdate"
    />
    <dialogInfo
      ref="dialog"
      :spointx="spointx"
      :spointy="spointy"
      :isEnglish="isEnglish"
    />
    

    <div id="mask" v-if="isShowBottomInfo || isLink" @click="touchMask"></div>
    <introDuction
      :isEnglish="isEnglish"
      :is-show-bottom-info="isShowBottomInfo"
      :is-gobottom="isGobottom"
      :audio-info="audioInfo"
    />
    <div class="feedBack">
      <feedBackUs
        :isEnglish="isEnglish"
        @successFeed="successFeed"
        :is-link="isLink"
        @changeLink="changeLink"
      />
    </div>
    <div
      class="message"
      :class="{ 'show-title': isShowTitle }"
      v-if="isMessage"
      v-html="title"
    ></div>
    <!-- 新版景点详情 -->
      <Audio
        ref="audio"
        :spointx="spointx"
        :spointy="spointy"
        :isEnglish="isEnglish"
        :audioInfo="audioInfo"
        @audioOpen='audioOpen'
        v-show="isShowAudio"
        :className="lineDialog?'higher':''"
        
      />
       
    <div class="touchDialog"  v-show="false">
    
    </div> 
      <img src="@/static/imgs/search.png" alt=""  @click="diaLog()" v-show="!searchDialog&& rightCheck!=true && lineDialog!=true &&isShowAudio!=true" class="sousuoliebiao ">
      <img src="@/static/imgs/position.png" alt=""  @click="getCenter" v-show="rightCheck!=true && lineDialog!=true &&isShowAudio!=true" class="sousuoliebiao position">
       
       
 
     <keep-alive include="searchCom">
    <search   :info="audioInfo"
      :list="audioList"
      :spointx="spointx"
      :spointy="spointy" :isEnglish="isEnglish" 
         @choseTour="showTourDialog"
      
       v-show="searchDialog"
      @closeDialog="closeDialog"
      > </search> -->
       </keep-alive>
     <loading class="loading" v-show="mapLoading" />


      <div class="marquee" v-if="audioInfo.notice!=null&&audioInfo.notice[0] && marqueeLigh"> 
          <div>
              <span @click="gotoNotice">
                <img :src="require('@/static/imgs/message.png')" alt="">
              </span>
              <div  @click="gotoNotice">
                   {{audioInfo?audioInfo.notice?audioInfo.notice[0]:'':''}}
              </div>
              <b   @click.stop="closeMarquee" >
                <img src="@/static/imgs/cha.png" alt="">
              </b>
          </div>
      </div>
      <div class="marquee1" v-if="audioInfo.notice!=null || !marqueeLigh" @click="gotoNotice">
            <img :src="require('@/static/imgs/message.png')" alt="">
      </div>
    <div class="footer" v-show="rightCheck!=true">
        <dl v-for="(v,i) in footerList" :key="i" @click="routelink(v)" >
          <dt>
             <iconx :type="v.img">
               
             </iconx>
             <span>

             </span>
          </dt>
          <dd>
            {{isEnglish ? v.english: v.name}}
          </dd>
        </dl> 
        
        <dl  @click="routelink(lineRoud)"  v-if="audioInfo.path_planning?audioInfo.path_planning.length>0:false">
          <dt>
             <iconx :type="lineRoud.img">
               
             </iconx>
             <span>

             </span>
          </dt>
          <dd>
            {{isEnglish ? lineRoud.english:lineRoud.name}}
          </dd>
        </dl>
        <dl  @click="routelink(atrcile)"  v-if="audioInfo.articles?audioInfo.articles[0]:false">
          <dt>
             <iconx :type="atrcile.img">
               
             </iconx>
             <span>

             </span>
          </dt>
          <dd>
            {{isEnglish ? atrcile.english:atrcile.name}}
          </dd>
        </dl>
        
    </div>

    <roadLine v-if="roadDialog" @closeLineRoad="closeLineRoad" @openLine="openLine" @choseLine="choseLine" :isEnglish="isEnglish"></roadLine>
    <allLine v-if="lineDialog" :tabCheck="tabCheck"  @closeDialog="closeDialog" @backRoad="backRoad" :isEnglish="isEnglish" />

  </div>
</template>
<script>
import mapTop from "@/components/map";
import dialogInfo from "@/components/dialogInfo";
import bottomTab from "@/components/bottomTab";
import Audio from "@/components/audio";
import loading from "@/components/loading";

import {
  GetDistance,
  serializeParams,
  isIos,
  amendPictureProperty,
} from "@/utils/util";
import html2canvas from "html2canvas";
import { throttle } from "lodash";
import feedBackUs from "@/components/feedback.vue";
import introDuction from "@/components/introduction.vue";
import * as constMap from "@/static/const.js";
import eventBus from "@/utils/eventBus";
import iconx from "@/components/iconx.vue";
import * as config from "@/api/api";
import search from "@/components/search.vue"
import { Swipe, SwipeItem } from 'vant';
import roadLine from "@/components/tourLineRoad.vue"
import allLine from "@/components/tourLineMsg.vue"
import Iconx from '../components/iconx.vue';

export default {
  name: "Index",
  components: {
    bottomTab,
    mapTop,
    dialogInfo,
    Audio,
    loading,
    iconx,
    feedBackUs,
    introDuction,
    search,
    Swipe, 
    SwipeItem,
    roadLine,
    allLine,
    Iconx
  },
  data() {
    
    return {
      client: config.client,
      isShowBottomInfo: false,
      bottom: "-355px",
      timer: null,
      mylat: null,
      mylng: null,
      isOpenAudio: false,
      options: { timeout: 1000 },
      audioInfo: {},
      audioList: [],
      isMessage: false,
      messageCount: false,
      isShowTitle: false,
      title: "",
      // 当前位置经度
      spointx: 0,
      // 当前位置纬度
      spointy: 0,

      openidData: {},
      URL: config.imgHost,
      isDrawImg: true,
      isGobottom: false,
      contentData: {},
      isLink: false,
      isSubmit: false,
      subMitType: "",
      mobile: "",
      desc: "",
      submitTypeTitle: "",
      true: false,
      isEnglish: false,
      sliderMap: constMap.sidebarEnglishMap,
      messageMap: constMap.messageEnglishMap,
      isBuy: false,
      weatherData: {},
      isCloseWeather: false,
      rightTab: false,
      tabDirection:'1',//导航栏放下 1为下  2为上
      searchDialog:false,
      mapLoading:true,
      isShowAudio:false,
      marqueeLigh:true,
      footerList:[
        {
          id:0,
          name:"游玩攻略",
          img:"a-zu37",
          url:"/tourGL",
          english:"introduction",
        },{
          id:3,
          name:"客服",
          img:"a-zu249",
          url:"/tourKF",
          english:"service",
        }
      ],
      atrcile:{
          id:4,
          name:"热门服务",
          img:"a-zu248",
          url:"/tourHD",
          english:"Popular",
        },
        lineRoud:{

          id:2,
          name:"游览路线",
          img:"a-zu77",
          url:'/tourLX',
          english:"Tour route",
        },
      roadDialog:false,
      lineDialog:false,
      tabCheck:0,
      rightCheck:false,
      wxhtml:"",
      isShowMiniShop:false
    };
  },
  watch:{
    marqueeLigh(val){
      this.marqueeLigh=val
    },
    spointx(val){
      this.spointx=val
      localStorage.setItem("lat",val)
    },
    spointy(val){
      this.spointy=val
      localStorage.setItem("log",val)

    },
     searchDialog(val){
      this.searchDialog=val
    },
    // 监听用户点击自动播放, 如果是自动,则开启自动定位,否则关闭自动定位
    isOpenAudio(val) {
      this.isMessage = true;
      if (!val) {
        this.title = `${
          this.isEnglish
            ? this.messageMap[3].english
            : this.messageMap[3].chinese
        }`;
        this.$refs.mapAddress.changeAutomaticId();
        // 隐藏自动播放的层
        this.$refs.mapAddress.CircleLine.setVisible(false);
      } else {
        this.title = `${
          this.isEnglish
            ? this.messageMap[4].english
            : this.messageMap[4].chinese
        }`;
        this.$refs.mapAddress.infoWindowMap.close();
      }
      this.timer = setTimeout(() => {
        this.isMessage = false;
        clearTimeout(this.timer);
        this.timer = null;
      }, 2000);
    },
  },
  // 进入导航前
  mounted() {
     
let that=this

     
    window.history.pushState(null, '语音导览', document.URL);
    // if(window.addEventListener){
    //   window.addEventListener('popstate', function () {
    //     //  alert(123456789)
    //     let boolean=localStorage.getItem("dialog")
    //     // alert(boolean)

    //     if(boolean){
    //       localStorage.setItem("dialog",'')
    //       that.searchDialog=false
    //       that.roadDialog=false
    //       // this.$router.replace({ path: '/HomePage' });
    //        window.history.pushState(null, '语音导览', document.URL);
    //        document.title = "语音导览";

    //     }else{
    //        that.searchDialog=false
    //       that.roadDialog=false
    //       document.title = "语音导览";
    //       // window.history.back()
    //     }
       
         
        
    //    });
    // }
       
  


    if (config.client == "h5") {
    this.getLocalInfo();
    setTimeout(() => {
      // 开启实时定位导航
      this.setCenterLocation();
    }, 3000);

    } else {
      // 获取openid
      if (config.code) {
        if (!JSON.parse(sessionStorage.getItem("openIdData") || "{}").openid) {
          config.getOpenid().then((res) => {
            let data = res.data.data;
            sessionStorage.setItem("openIdData", JSON.stringify(data));
            this.getLocalInfo();
            setTimeout(() => {
              // 开启实时定位导航
              this.setCenterLocation();
            }, 3000);
          });
        } else {
          this.getLocalInfo();
          setTimeout(() => {
            // 开启实时定位导航
            this.setCenterLocation();
          }, 3000);
        }
      }
    }
    this.getConfig();

    var btn = document.getElementById('launch-btn');
      // btn.addEventListener('launch', function (e) {
      //     console.log('success');
      // });
      // btn.addEventListener('error', function (e) {
      //     console.log('fail', e.detail);
      // });
    // console.log(this)
  },
  // 页面离开取消随时监听用户位置
  beforeRouteLeave(to, from, next) {
    this.showClearWatch();
    next();
  },
  beforeDestroy() {
    this.showClearWatch();
  },
 
  methods: {
   closeMarquee(){
     console.log(123465)
     this.marqueeLigh=false
   },
handleLaunchFn(e) {
      console.log('success', e);
      alert("成功")
    },
    handleErrorFn(e) {
      console.log('fail', e.detail);
       alert("失败")
    },
    //去商城
    gotoShop(){
    
      
      if(this.audioInfo.settings){
        if(this.audioInfo.settings.isMini==2){
          window.open(this.audioInfo.settings.h5Link)
        this.isShowMiniShop=false
        }else{
         

      
        }
      }
    },
    //打开vr
    gotoVr(){
      if(this.audioInfo.settings){
        if(this.audioInfo.settings.vrLink){
          window.open(this.audioInfo.settings.vrLink)

        }
      }
    },
    //打开选项功能栏
    openRight(){
      this.rightCheck=true
      
      
              $('.right-mark').animate({width:'toggle'},550);  
        
    },
    closeRightCheck(){
      this.rightCheck=false
      $('.right-mark').animate({width:'toggle'},500);
    },
    //关闭路线
    choseLine(data){
      this.tabCheck=data 
    },
    //打开路线
    openLine(data){
            this.lineDialog=data
    },
    //关闭路线弹框
    closeLineRoad(data){
      
      this.roadDialog=data
    },
    //退出到选择路线
    backRoad(data){
      this.roadDialog=false
      this.lineDialog=false
      
    },
    //底部菜单跳转页面
    routelink(item){
      if(item.name=="游览路线"){
          this.roadDialog=true
      }else{
        if(item.id==4){
          window.open(this.audioInfo.articles)
        }else{
         this.$router.push({path:item.url,query:{
           isEnglish:this.isEnglish
         }})
        }
      }
    },
    //跳转公告页面
    gotoNotice(){
      this.$router.push({
        path:"/notice",
        query:{
          message:this.audioInfo.notice[1]
        }
      })
    },

    //打开播放
    audioOpen(boolean){
      this.isShowAudio=boolean
      // console.log(boolean)
    },
    lineUpdate(data){
      this.roadDialog=data
      this.lineDialog=data
      // this.$refs.mapAddress.getAddress(this.contentData, data);
      // console.log(data)
    },
    closeDialog(val){
      this.searchDialog=val
      // this.roadDialog=val
    },
    showTourDialog(obj){
        // console.log(obj)
    },
    diaLog(){
      localStorage.setItem("dialog",true)
      
      this.searchDialog=true
      this.setCenterLocation()
      if (window.__wxjs_environment === "miniprogram") {
            this.$wx.getLocation({
              type: "gcj02",
              success: (res) => {
                // alert(JSON.stringify(res))
                const latitude = res.latitude;
                const longitude = res.longitude;
                this.spointx = Number(latitude);
                this.spointy = Number(longitude);
                // alert(typeof(this.spointx))
                // alert(typeof(this.spointy))
                // alert(this.spointy)
                // alert(this.spointy)
              },
              fail:(err)=>{
                // console.info(err,11111)
              }
            });
          }
    },
    complete(){
      // console.log(132456798)
      window.open(this.audioInfo.complete_link)
    },
    outOrin() {
      // console.log("sahdjkahsjkdha");
     
      this.rightTab = !this.rightTab;
      if(this.rightTab){
        $(".Tab").slideDown()
      }else{
        $(".Tab").slideUp()
      }
    },
    getLocalInfo() {
      this.initEventBus();
      this.getAudioInfo();
      let that = this;
      if (window.__wxjs_environment != "miniprogram") {
        // alert("我从h5打开")
      //打开的方式不是小程序的时候 走h5的获取位置信息
        this.geolocation = new qq.maps.Geolocation(
          "BN6BZ-URCWF-3NTJD-N6J24-YTMS2-IPBZM",
          "audioApp"
        ); // 获取当前位置信息
      }
    },
    getAudioInfo() {
      let p1 = this.getAudio();

      let p2 = this.addExplanatio();
      Promise.all([p1, p2]).then((values) => {
        this.$refs.mapAddress.getAddress(this.contentData, this.audioList);
        this.searchStatus(config.is_eng);

        this.tabDirection= this.audioInfo.direction
        // console.log(this.audioInfo)
        setTimeout(() => {
          // if (window.__wxjs_environment == "miniprogram") {
            // alert("我从h5打开")
            this.getConfig(); // 获取当前位置信息
          // }

          this.searchBuy();
        }, 1000);
      });
    },
    touchMask(e) {
      if (e.target.id === "mask") {
        this.isGobottom = true;
        this.isShowBottomInfo = false;
        this.isLink = false;
      }
    },
    changeLink(val) {
      console.log(val)
      this.isLink = val;
    },
    initEventBus() {
      eventBus.on("showMessage", (title) => {
        let time = 2000;
        if (
          title === "您当前不在景区范围内" ||
          title === "You are not in the scenic area at present"
        ) {
          if (this.messageCount) return;
          this.messageCount = 1;
        } else {
          time = 3500;
        }
        this.isMessage = true;
        this.title = title;
        this.timer = setTimeout(() => {
          this.isShowTitle = false;
          this.isMessage = false;
          clearTimeout(this.timer);
          this.timer = null;
        }, time);
      });
    },
    successFeed() {
      this.showMessage(
        `${
          this.isEnglish
            ? this.messageMap[2].english
            : this.messageMap[2].chinese
        }`
      );
      setTimeout(() => {
        this.isLink = false;
      }, 500);
    },
    // 定位当前位置
    setCenterLocation() {
      this.geolocation.getLocation(
        this.showPosition,
        this.showErr,
        this.options
      );
      this.showWatchPosition();
    },
    changeWeather() {
      this.isCloseWeather = !this.isCloseWeather;
    },
    changeDrawImg() {
      this.isDrawImg = !this.isDrawImg;
      this.$refs.mapAddress.drawImg(this.isDrawImg);
    },
    //判断手绘图是否加载完毕 加载完毕去掉loading状态
    changeLoading() {
      
      this.mapLoading = false;
    },
    getConfig() {
      let that = this;
      config.getConfig().then((res) => {
        // 获取授权
        if (res.data.success) {
          localStorage.setItem("appid_vote", res.data.data.appId);
          // console.log( res.data.data)
          this.$wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.data.appId,
            timestamp: parseInt(res.data.data.timestamp),
            nonceStr: res.data.data.nonceStr,
            signature: res.data.data.signature,
            jsApiList: res.data.data.jsApiList,
            openTagList: ['wx-open-launch-weapp']
          });
       
         
    //判断当前如果是小程序端 获取地理位置使用小程序的内置方法
          if (window.__wxjs_environment === "miniprogram") {
            this.$wx.getLocation({
              type: "gcj02",
              success: (res) => {
                // alert(JSON.stringify(res))
                const latitude = res.latitude;
                const longitude = res.longitude;
                this.spointx = Number(latitude);
                this.spointy = Number(longitude);
                // alert(typeof(this.spointx))
                // alert(typeof(this.spointy))
                // alert(this.spointy)
                // alert(this.spointy)
              },
              fail:(err)=>{
                console.info(err,11111)
              }
            });
          }
          const uri = `${config.apiHost}/mp/audio-guide.html?merchantId=${config.merchantId}&ditch=move&audio_id=${config.AudioId}&appid=${config.appId}`;
          const obj = {
            url: `${config.apiHost}/mp/audio-guide.html`,
            merchantId: config.merchantId,
            ditch: "move",
            audio_id: config.AudioId,
            appid: config.appId,
          };
          this.$wx.ready(() => {
           
            const options = {
              title: `${this.audioInfo.share_title || "语音导览"}`, // 分享标题
              desc: `${this.audioInfo.share_desc || this.audioInfo.address}`,
              link: `${config.apiHost}/mp/audio-guide.html?merchantId=${config.merchantId}&ditch=move&audio_id=${config.AudioId}&appid=${config.appId}`,
              imgUrl: this.audioInfo.share_url
                ? this.URL + this.audioInfo.share_url
                : this.URL + this.audioInfo.img,
              success: () => {},
            };

            this.$wx.updateTimelineShareData &&
              this.$wx.updateTimelineShareData(options);
            this.$wx.updateAppMessageShareData &&
              this.$wx.updateAppMessageShareData(options);
            this.$wx.onMenuShareTimeline &&
              this.$wx.onMenuShareTimeline(options);
            this.$wx.onMenuShareAppMessage &&
              this.$wx.onMenuShareAppMessage(options);
          });
        }
      });
    },
    showPrizeDialog() {
      let _this = this;
      // if (Number(this.markerList[index].type) === 1 && !this.isBuy) {
      this.$weui.dialog({
        title: `${_this.contentData.price}${
          _this.isEnglish
            ? constMap.payDialogEnglishMap[0].english
            : constMap.payDialogEnglishMap[0].chinese
        }`,

        content: `${
          _this.isEnglish
            ? constMap.payDialogEnglishMap[1].english
            : constMap.payDialogEnglishMap[1].chinese
        }`,
        className: "custom-classname",
        buttons: [
          {
            label: `${
              _this.isEnglish
                ? constMap.payDialogEnglishMap[2].english
                : constMap.payDialogEnglishMap[2].chinese
            }`,
            type: "default",
            onClick: function () {
              _this.isBuy = false;
            },
          },
          {
            label: `${
              _this.isEnglish
                ? constMap.payDialogEnglishMap[3].english
                : constMap.payDialogEnglishMap[3].chinese
            }`,
            type: "primary",
            onClick: function () {
              _this.buyMethods();
            },
          },
        ],
      });
    },

    // 去支付
    buyMethods() {
      let _this = this;
      let datas = {
        user_id: JSON.parse(sessionStorage.getItem("openIdData") || "{}").id,
        merchant_id: JSON.parse(sessionStorage.getItem("openIdData") || "{}")
          .merchant_id,
        price: _this.contentData.price,
        settle_price: _this.contentData.settle_price,
        we_openid: config.openid,
        explanatio_id: _this.audioList[0].explanatio_id,
        name: JSON.parse(sessionStorage.getItem("openIdData") || "{}").nickname,
      };

      config.toBuy(datas).then((res) => {
        if (res.data.success) {
          let datass = res.data.data;

          WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: datass.appId, // 公众号名称，由商户传入
              timeStamp: datass.timeStamp, // 时间戳，自1970年以来的秒数
              nonceStr: datass.nonceStr, // 随机串
              package: datass.package,
              signType: "MD5", // 微信签名方式：
              paySign: datass.paySign, // 微信签名
            },
            function (res) {
              if (res.err_msg === "get_brand_wcpay_request:ok") {
                config.isBuy(_this.audioList[0].explanatio_id).then((res) => {
                  // 判断是否购买过
                  if (res.data.success) {
                    if (res.data.data.items.length !== 0) {
                      _this.isBuy = true;
                      // _this.automaticId = null;
                      localStorage.setItem("isBuy", true);
                    }
                  }
                });
              } else {
                this.$weui.topTips("支付失败", 2000);
              } // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
            }
          );
        }
      });
    },

    searchBuy() {
      config.isBuy(this.audioList[0].explanatio_id).then((res) => {
        if (res.data.success) {
          this.isBuy = res.data.data.items.length !== 0;
        }
      });
    },
    showMessage(title) {
      this.title = title;
      this.isMessage = true;
      this.timer = setTimeout(() => {
        this.isShowTitle = false;
        this.isMessage = false;
        clearTimeout(this.timer);
        this.timer = null;
      }, 2000);
    },

    getCenter() {
      this.$refs.mapAddress.setMapCenterOnce();
    },
    changeAudioState() {
      this.$refs.mapAddress.changeAudioState();
      this.$refs.tabs.changeIcon();
    },
    changeOpenAudio() {
      this.isOpenAudio = false;
    },

    changeEnglish() {
      this.isEnglish = !this.isEnglish;
      this.$refs.mapAddress.changeEngStatus(this.isEnglish);
    },
    showPosition(position) {
      this.spointx = Number(position.lat);
      this.spointy = Number(position.lng);
      this.$refs.mapAddress.setCenter(
        position.lat,
        position.lng,
        this.isOpenAudio
      );
    },
    showErr() {
      // console.log("定位失败");
    },

    // 开启自动定位
    showWatchPosition() {
      this.geolocation.watchPosition(throttle(this.showPosition, 5000));
    },
    // 取消自动定位
    showClearWatch() {
      this.geolocation.clearWatch();
    },
    getAudio() {
      // console.log("首页信息");

      // 获取首页信息

      return new Promise((resolve, reject) => {
        config.getAudio().then((res) => {
          // console.log(res.data.data);
          res.data.data.items.forEach((element) => {
            if (element.name && element.name.length > 10) {
              // element.name = element.name.slice(0, 9) + "...";
            }
            // if (element.name_eng && element.name_eng.length >= 23) {
            //   element.name_eng = element.name_eng.slice(0, 23) + "...";
            // }
            element.content = amendPictureProperty(element.content);
            element.content_eng = amendPictureProperty(element.content_eng);
          });
          this.audioList = res.data.data.items;
          localStorage.setItem("audioList",JSON.stringify( res.data.data.items))
          this.$refs.audio.setDefaultMusic(res.data.data.items[0]);
          resolve();
        });
      });
    },
    feedBack() {
      // this.isSubmit = false;
      // this.subMitType = "";
      this.isLink = !this.isLink;
    },

    addExplanatio() {
      return new Promise((resolve, reject) => {
        config.addExplanatio().then((res) => {
          if (res.data.success) {
            this.audioInfo = res.data.data;
            if(JSON.parse(res.data.data.map_imgs).length==0){
              this.mapLoading = false;
            }else{
              
              this.changeLoading()
            }
             this.isShowMiniShop=res.data.data.settings?res.data.data.settings.isMini==1 ? true:false:false
            // console.log(111111, this.audioInfo);
            localStorage.setItem("mapImgArr",res.data.data.map_imgs)
            localStorage.setItem("tourInfo",JSON.stringify(res.data.data))
            let obj = res.data.data;
            let { name, address, content, content_eng } = obj;
            if (name && name.length > 10) {
              // obj.name = name.slice(0, 9) + "...";
            }
            if (address && address.length > 30) {
              obj.address = address.slice(0, 29) + "...";
            }
            obj.content = amendPictureProperty(content);
            obj.content_eng = amendPictureProperty(content_eng);
            obj.inlet_and_outlet.forEach((item) => {
              if (item.name && item.name.length > 10) {
                // item.name = item.name.slice(0, 9) + "...";
              }
              // if (item.name_eng && item.name_eng.length > 23) {
              //   item.name_eng = item.name_eng.slice(0, 22) + "...";
              // }
            });
            obj.path_planning.forEach((item) => {
              if (item.name && item.name.length > 16) {
                item.name = item.name.slice(0, 15) + "...";
              }
              // if (item.name_eng && item.name_eng.length > 40) {
              //   item.name_eng = item.name_eng.slice(0, 39) + "...";
              // }
            });
            res.data.data = obj;
            this.contentData = res.data.data;
            resolve();
          }
        });
      });
    },
    // 判断是否扫单个景点二维码进来的 或 分享单个景点进来或链接的
    searchStatus(type) {
      // 分享的是英文码
      if (type && Number(type) === 1) {
        this.isEnglish = true;
        this.$refs.mapAddress.changeEngStatus(this.isEnglish);
      }
    },
    showHelp() {
      this.$refs.dialog.setInfo(this.audioInfo);
    },
    changeOpenAudio() {
      this.isOpenAudio = !this.isOpenAudio;
    },
    showInfo() {
      this.isShowBottomInfo = true;
      this.isGobottom = false;
    },
    close() {
      this.isShowBottomInfo = false;
      this.bottom = "-355px";
    },
  },
  
};
</script>
<style  scoped lang='scss'>
.container {
  width: 100%;
  height: 100%;
  position: relative;
}
.outOrin {
  position: absolute;
  top: 120px;
  right: 3px;
  font-size: 12px;
  z-index: 99;
  i{
    font-size: 30px;
  }

}
.feedBack{
  zoom:1;
  overflow:hidden;
  >div{
    zoom:1;
    overflow:hidden;
  }
}
.miniShop{
  width: 50px;
  height: 50px;
  position: absolute;
  z-index: 99999;
  // background-color: yellow;
  right: 15px;
  top: 175px;
}
.right-fun{
  width: auto;
  height: auto;
  padding: .2rem .1rem;
  border-radius: 50px;
  box-sizing: border-box;
  background-color: #ffffff;
  position: absolute;
  top: 120px;
  right: 15px;
  font-size: 12px;
  z-index: 99;
  >ul{
    list-style: none;
    li{
      list-style: none;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 10px;
      box-sizing: border-box;
      color: #707070 ;
      span{
        padding-top: 5px;
        box-sizing: border-box;
      }
      img{
        width: .5rem;
        height: auto;
      }
    }
    li:last-child{
      padding: 0;
    }
  }
}

.right-mark{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 999999 !important;
  // background-color: #fff;
  top: 0;
  right: 0;
  display: flex;
  div{
    flex: none;
  }
  >div:first-child{
    width: 20%;
    height: 100%;
    background-color: #707070;
    opacity: .6;
  }
  >div:last-child{
    flex: 1;
    background-color: #fff;
  }
  .Tab{
    width: 100%;
    height: 100%;
    display: flex;
    font-size: 16px;
    >div{
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      padding: .3rem;
      box-sizing: border-box;
      >div{

        width: 100%;
        display: flex;
 justify-content: space-between;
      padding: .2rem 0;
      box-sizing: border-box;
      border-bottom: 1px solid #ccc;
        >div{
          display: flex;
          align-items: center;
          i{
            padding-right: 5px;
            font-size: 20px;
          }
        }
       
      }
    }
  }
}
.footer{
  width: 100%;
  height: auto;
  display: flex;
  position: fixed;
  bottom: 0;
  z-index: 2;
  font-size: 14px;
  flex-wrap: nowrap;
  background: #ffffff;
  // padding: 10px 0 ;
  box-sizing: border-box;
  align-items: center;
  >dl{
    flex: 1;
    // width: 25%;
    height: auto;
    // border-right: 1px solid #ccc;
    dt,dd{
      width: 100%;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
    }
    dt i{
      font-size: 20px;
      color: #333;
    }
    
    dt span{
      position: absolute;
      display: flex;
      height: 80%;
      width: 1px;
      background: #ccc;
      right: 0;
      top: 50%;
      transform: translateY(-10%);
    }
  }
  dl:last-child span{
      width: 0;
      height: 0;
    }
}

.marquee1{
   position: absolute;
   width: 40px;
   height: 40px;
  top: 65px;
  // padding: 15px;
  // box-sizing: border-box;
  left: 15px;
  z-index: 10;
  background-color: #fff;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  img{
    width: 70%;
    height: 70%;
  }
}

.marquee{
  width: 100%;
  height: 40px;
  position: absolute;
  top: 65px;
  z-index: 99;
  padding: 0 15px;
  box-sizing: border-box;
  >div{
    width: 100%;
    height: 100%;
    background: #ffffff;
    border-radius: 50px;
    opacity: .9;
    display: flex;
      font-size: 14px;
    span{
      display: flex;
      width: auto;
      height: 100%;
      padding: 6px;
        font-size: 14px;
      // background: #ffffff;

      box-sizing: border-box;
      img{
        width: auto;
        height: 100%;
      }
    }
     b{
       display: flex;
       align-items: center;
       justify-content: center;
        position: absolute;
        right: 30px; 
        font-size: 18px !important;
        z-index: 99999;
        font-style: none;
        height: 100%;
        font-weight: normal;
        img{
          width: 30px;
          height: auto;
        }
      }
    
    div{
      flex: 1;
        font-size: 14px;
        display: flex;
        align-items: center;
       
      >div{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
          font-size: 14px;
        >div{
          width: 100%;
          height: 100%;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          font-size: 14px;
          padding-left: 15px;
          box-sizing: border-box;
        }
      }
      
    }
  }
}
.rotate{
  
  transform: rotateZ(90deg);
  transition:transform .5s;
}
.normal{
  transform: rotateZ(0deg);
  transition:transform .5s;
}


@keyframes hideTab {
  from {
    height: 300px;
    display: block;
  }
  to {
    height: 0px;
    display: none;
  }
}
@keyframes showTab {
  from {
    height: 0px;
    display: none;
  }
  to {
    height: 300px;
    display: block;
  }
}
.hideTab {
  display: none;
}

// .showTab {
//   animation: showTab 0.5s ease-in 0s forwards;
// }

.show-info {
  top: 130px !important;
  transition: top 0.35s ease-in-out !important;
}
.go-bottom {
  top: -500px !important;
  transition: top 0.25s ease-in-out !important;
}
.aside {
  z-index: -1000;
  // position: absolute;
  // animation: showTab 0.5s ease-in 0s forwards;
  right: 3px;
  // z-index: 10;
  display: inline-block;
  // top: 64px;
  width: 36px;
  height: 94px;
  padding-left: 2px;
  box-sizing: border-box;
  border: 1px solid rgb(239, 239, 239);
  background-color: rgba(255, 255, 255, 0.95);
  text-align: center;
  border-radius: 3px;
  // display: none;
 
    // animation: hideTab 0.5s ease-in 0s forwards;
  
}
.aside-info,
.asild-help {
  width: 100%;
  height: 47px;
  font-size: 11px;
  font-weight: 300;
  // animation: hideTab 0.5s ease-in 0s forwards;
  // display: none;
  //  animation: showTab 0.5s ease-in 0s forwards;
}

.asild-help {
  border-top: 1px solid rgb(239, 239, 239);
  // top: 58px;
}


.open-audio,
.open-draw-img,
.feed-back,
.open-translate {
  width: 34px;
  height: 42px;
  // cursor: pointer;
  position: absolute;
  right: 0px;
  background-color: rgba(255, 255, 255, 0.95);
  text-align: center;
  // line-height: 32px;
  border-radius: 4px;
  // z-index: 1000;
  display: flex;
  flex-direction: column;
  span {
    display: inline-block;
    position: relative;
    // position: absolute;
    // top: 27px;
    left: 0;
    width: 100%;
    height: 12px;
    line-height: 12px;
    font-size: 11px;
  }
}
.container .locations {
  position: absolute;
  background-color: none !important;
}
.locations {
  bottom: 260px;
  left: 3px;
  height: 38px;
  i {
    font-size: 24px;
  }
  z-index: 100;
  background-color: none !important;
  img{
    width: 40px;
    height: auto;
  }
}
.eng-slider-width {
  width: 65px;
  transition: width 0.16s ease-in-out;
}
.feed-back {
  bottom: 90px;
  left: 3px;
  height: 43px;
  i {
    font-size: 17px;
  }
  span {
    font-size: 10px;
  }
}
.open-audio {
  top: 164px;
  i {
    font-size: 17px;
  }
}
.open-draw-img {
  top: 115px;
  i {
    font-size: 17px;
  }
}
.open-translate {
  top: 213px;
  height: 43px;
  span {
    line-height: 16px;
  }
  i {
    font-size: 17px;
  }
}
.complete-link{
  right: 0px;
  width: 45px;
  position: absolute;
  height: 50px;
  top: 265px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 99;

  i{
    position: absolute;
    top: -2px;
    font-size:26px;
  }
  span{
    font-size: 8px;
    position: absolute;
    bottom: 0px;
  }
}
.message {
  position: absolute;
  bottom: 35px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0 26px;
  background-color: rgba($color: #000000, $alpha: 0.5);
  line-height: 26px;
  border-radius: 16px;
  text-align: center;
  color: #ffffff;
  font-size: 13px;
  letter-spacing: 1px;
  z-index: 1000000000000000;
}
.show-title {
  line-height: 20px;
  width: 260px;
  border-radius: 10px;
}
.bottomInfo {
  width: 355px;
  height: 148px;
  position: fixed;
  bottom: -355px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ffffff;
  z-index: 10000;
  border-radius: 9px;
  img {
    width: 63px;
    height: 63px;
    border-radius: 50%;
    margin-left: 17px;
    margin-top: -20px;
  }
  .title {
    display: inline-block;
    width: 225px;
    height: 52px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    line-height: 52px;
    color: rgb(195, 195, 195);
    margin-top: -5px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .address,
  .begin-time {
    width: 92%;
    position: absolute;
    left: 4%;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 1px;
    p {
      display: inline-block;
      width: 226px;
      height: 100%;
      vertical-align: top;
      line-height: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    i {
      display: inline-block;
    }

    span {
      display: inline-block;
      width: 89px;
      height: 29px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      vertical-align: top;
    }
  }
  .address {
    height: 60px;
    top: 50px;
  }
  .begin-time {
    height: 30px;
    border-top: 1px dashed rgb(195, 195, 195);
    top: 114px;
  }
}
#mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba($color: #000000, $alpha: 0.4);
  z-index: 100000000;
}

.loading {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100vh;
}
.touchDialog{
  width: 100%;
  height: 80%;
  position: fixed;
  bottom: -60%;
  z-index: 999;
  background: #ffffff;
}
.touchDialog>div:nth-child(1){
  top:0;
}
#mapTop{
  height: 100%;
}
.sousuoliebiao{
   width: 60px;
  height: 60px;
  position: fixed;
 
  bottom: 60px;
  padding: 10px 10px;
  box-sizing: border-box;
  z-index: 99;
  display: flex;
  justify-content: space-between;
   right: 0px;
 
}
.position{
  left:0px;
}



.container {
  .dialog-search-container{
    position: absolute;
    top: 0;
    z-index: 99999;
    background: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/new-index.vue